import { useGlobalContext } from '@/context/Global/GlobalContext';
import axiosV2 from '@/data/api/axiosv2';
import { isString } from '@/utils/functions';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useEffect } from 'react';

const HTTP_ERROR_UNAUTHORIZED = 401;
const HTTP_ERROR_FORBIDDEN = 403;

export function AxiosSessionHandlerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { clearSession } = useGlobalContext();

  // Setup Response Interceptor
  useEffect(() => {
    const id = axiosV2.interceptors.response.use(
      (response: AxiosResponse) => {
        const data = response.data;
        if (data?.error) {
          const validationMessages = data.errorMessage?.validationMessages;
          const error =
            validationMessages && validationMessages.length > 0
              ? Error(validationMessages.join(', '))
              : new Error(data.errorMessage?.message || 'An error occurred');
          return Promise.reject(error);
        }
        return data;
      },
      (error: AxiosError) => {
        if (
          error.status === HTTP_ERROR_UNAUTHORIZED ||
          error.status === HTTP_ERROR_FORBIDDEN
        ) {
          clearSession();
          return Promise.reject(new Error('No autorizado'));
        }

        if (axios.isCancel(error)) return Promise.reject(error);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const axiosError: any = error;
        const errorMessage = axiosError?.response?.data?.message;
        if (isString(errorMessage)) return Promise.reject(errorMessage);
        return Promise.reject(error);
      }
    );

    return () => axiosV2.interceptors.response.eject(id);
  }, []);

  return <>{children}</>;
}
